import React from 'react';
import { useNavigate } from 'react-router-dom';

const OnboardingSuccess = ({ gymData, onContinue }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl p-6 sm:p-8 border-2 border-slate-900 shadow-retro">
      <div className="text-center">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-retro">
          <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-2">
          {gymData.gym.name} is Live! 🎉
        </h2>
        <p className="text-lg text-slate-700 mb-8">
          Your gym is now set up on BoardRez. Let's get you started!
        </p>

        {/* Quick Start Guide */}
        <div className="bg-gradient-to-br from-teal-50 via-purple-50 to-magenta-50 rounded-xl p-6 border-2 border-slate-900 mb-8 text-left">
          <h3 className="text-sm font-bold text-slate-600 uppercase tracking-wide mb-4 flex items-center gap-2">
            <span className="w-1 h-4 bg-teal-500 rounded"></span>
            Quick Start
          </h3>

          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 border-2 border-slate-900">
                <span className="text-white font-bold text-sm">1</span>
              </div>
              <div>
                <p className="font-bold text-slate-900">Explore Your Dashboard</p>
                <p className="text-sm text-slate-700">View reservations, manage boards, and see analytics</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0 border-2 border-slate-900">
                <span className="text-white font-bold text-sm">2</span>
              </div>
              <div>
                <p className="font-bold text-slate-900">Share Your Booking Link</p>
                <p className="text-sm text-slate-700">Post it on your website and social media</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-magenta-500 rounded-full flex items-center justify-center flex-shrink-0 border-2 border-slate-900">
                <span className="text-white font-bold text-sm">3</span>
              </div>
              <div>
                <p className="font-bold text-slate-900">Invite Your Staff</p>
                <p className="text-sm text-slate-700">Add team members to help manage reservations</p>
              </div>
            </div>
          </div>
        </div>

        {/* Trial Info */}
        <div className="bg-sunshine-100 border-2 border-sunshine-500 rounded-lg p-4 mb-8">
          <p className="text-sunshine-800 font-semibold text-sm">
            ⭐ Your 30-day free trial has started. You won't be charged until the trial ends.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3">
          <a
            href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 bg-white hover:bg-slate-50 text-slate-700 font-bold rounded-lg border-2 border-slate-900 shadow-retro hover:shadow-retro-hover transition-all text-center touch-manipulation"
          >
            📺 Watch 2-Min Tour
          </a>
          {onContinue ? (
            <button
              onClick={onContinue}
              className="flex-1 px-6 py-4 bg-teal-500 hover:bg-teal-600 text-white font-bold rounded-lg border-2 border-slate-900 shadow-retro hover:shadow-retro-hover transition-all touch-manipulation"
            >
              Continue to Marketing Materials →
            </button>
          ) : (
            <button
              onClick={() => navigate('/dashboard')}
              className="flex-1 px-6 py-4 bg-teal-500 hover:bg-teal-600 text-white font-bold rounded-lg border-2 border-slate-900 shadow-retro hover:shadow-retro-hover transition-all touch-manipulation"
            >
              Go to Dashboard →
            </button>
          )}
        </div>

        {/* Support Info */}
        <div className="mt-8 pt-6 border-t-2 border-slate-900">
          <p className="text-sm text-slate-600">
            Need help? Text us at{' '}
            <a href="tel:+13035551234" className="font-bold text-teal-600 hover:text-teal-700">
              (303) 555-1234
            </a>
            {' '}or email{' '}
            <a href="mailto:support@boardrez.com" className="font-bold text-teal-600 hover:text-teal-700">
              support@boardrez.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OnboardingSuccess;
